export default "__VITE_ASSET__BYC2a71b__"